'use strict'
import settings from "@/settings";
import constants from "@/constants"
import calculateMixins from "@/mixins/calculateMixins";
import httpClient from "@/services/http.services";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import abortMixins from "@/mixins/abortMixins";
import {ensureModalDataFresh, hasModalCache} from "@/services/metaResources.service";
import webSocketMixins from "@/mixins/webSocketMixins";

const datatableMixins = {
    mixins: [calculateMixins, showErrorsMixins, abortMixins, webSocketMixins],
    emits: ['update-items'],
    data() {
        return {
            dataIsSending: false,
            showModals: false,
            loadingError: false,
            _lastModalCtxKey: null,
            routePathAtMount: null,
            itemNotFound: false,
            itemsReceivedTimestamp: null,
            modalDataIsLoading: false,
            confirmDeleteModalIsLoading: false,
            orderToWaitingData: null,
            changeOrderToWaitingModal: false,
            searchData: null,
            processedSearchValue: null,
            selectedCategory: null,
            selectedCategoryId: null,
            selectedType: null,
            selectedTypeId: null,
            fromTimestamp: null,
            toTimestamp: null,
            warehouseItems: null,
            masters: null,
            responsibles: null,
            taxes: null,
            services: null,
            suppliers: null,
            employees: null,
            areas: null,
            disableEditButton: false,
            isLoading: true,
            dataTableIsLoading: false,
            sort: {
                column: 'id',
                direction: '-',
            },
            items: [],
            itemModal: false,
            itemDeleteModal: false,
            confirmItemDeleteModal: false,
            confirmItemsMultipleDeleteModal: false,
            item: {},
            updatedItemId: null,
            updatedItemsIds: [],
            itemToDelete: {},
            pagination: {
                totalCount: null,
                pageCount: null,
                currentPage: 1,
                perPage: 25
            },
            addedItems: [],
            selectedItems: [],
            selectAllCheckbox: [],
            openedItemsIds: [],
            settings,
            constants,
            getItemsAfterRouteChanging: true,
        }
    },
    watch: {
        userCanGetData: {
            immediate: false, //DONT TOUCH!
            handler(value) {
                if (!value) return
                const isTenantPage = this.$route.meta?.context === 'tenant'
                const mode = this.$store.getters.effectiveMode
                if (isTenantPage && mode !== 'tenant') return
                if (this.routePathAtMount && this.$route.path !== this.routePathAtMount) return

                this.getPageData?.()

                if (this.$store.getters.isSystemMode) {
                    this.$store.commit('updateLocationData', {
                        locale: 'et-EE',
                        currency: 'EUR',
                        timezone: 'Europe/Tallinn'
                    })
                }
            }
        },
        $route: {
            immediate: true,
            handler(to, from) {
                if (!to?.path || !from?.path) return
                if (to.path === '/login' || !this.getItemsAfterRouteChanging) return

                if (from.path === this.routePath && to.path !== this.routePath) return

                if (to.path !== this.routePath) return

                if (this.itemsReceivedTimestamp && (Date.now() - this.itemsReceivedTimestamp < 300)) return

                this.checkRouteQuery()
                this.getItems?.()
            },
        },
        selectedItems() {
            this.checkAllItemsAreSelected()
        },
        '$store.state.firstLayerIsOpened'(value) {
            if (!value) {
                if (this.itemModal) {
                    this.closeItemModal()
                }
                if (this.confirmItemDeleteModal) {
                    this.closeConfirmItemDeleteModal()
                }
                if (this.confirmItemsMultipleDeleteModal) {
                    this.closeConfirmItemsMultipleDeleteModal()
                }
                if (this.changeOrderToWaitingModal) {
                    this.closeChangeOrderToWaitingModal()
                }
            }
        },
    },
    methods: {
        hasTime(value) {
            const raw = Number(value)
            return Number.isFinite(raw) && raw > 0
        },
        async getModalDataOnMounted() {
            const tenantId = this.$store.getters.tenantId
            const locationId = this.$store.getters.locationId
            const key = `${tenantId}:${locationId}`

            const keyChanged = (this._lastModalCtxKey && this._lastModalCtxKey !== key)
            this._lastModalCtxKey = key

            const force = keyChanged ? !hasModalCache({ tenantId, locationId }) : false

            return this.getModalData({force})
        },
        checkModalDataIsFresh() {
            const tenantId = this.$store.getters.tenantId;
            const locationId = this.$store.getters.locationId;

            ensureModalDataFresh({ tenantId, locationId })
                .then((r) => {
                    if (r?.refreshed) this.getModalData({ force: false });
                })
                .catch(() => {});
        },
        // handleRoute() {
        //     // if (!this.routePath || !this.$route.path || this.$route.path !== this.routePath) {
        //     if (!this.routePath || !this.$route.path) {
        //         return
        //     }
        //     if (this.$route.path === '/login' || !this.getItemsAfterRouteChanging) {
        //         return
        //     }
        //
        //     if (this.itemsReceivedTimestamp && (Date.now() - this.itemsReceivedTimestamp < 300)) return
        //     this.checkRouteQuery()
        //     this.getItems()
        // },
        async onEstimateDelete() {
            const res = await this.deleteItem()
            if (res?.success) {
                this.getNewOffersCount()
                this.sendCreateEstimateWebSocket()
            }
        },
        async getOrderById(id) {
            this.dataIsSending = true
            try {
                const { data, status } = await httpClient.post(`order/get-by-id?expand=${this.fieldsExpand}`, { id })
                if (status === 200 && data?.success && data.item) {
                    return data.item
                } else {
                    return null
                }
            } catch(err) {
                this.showError(err)
            } finally {
                this.dataIsSending = false
            }
        },
        exitFocusedMode() {
            const query = { ...this.$route.query }
            delete query.show

            this.$router.replace({ path: this.$route.path, query })
        },
        showAll() {
            // const query = { ...this.$route.query }
            // delete query.unanswered
            // delete query.answered
            // delete query.pending
            //
            // this.$router.replace({ path: this.$route.path, query })


            this.$router.replace({ path: this.$route.path })
        },
        scrollToTop() {
            window.scrollTo(0, 0)
        },

        async deleteItem() {
            if (this.billingActionIsRestricted?.()) {
                this.closeConfirmItemDeleteModal()
                return false
            }

            if (!this.deleteItemUrl || !this.itemToDelete?.id || !this.$store.getters.userCanGetData) {
                return null
            }

            this.modalDataIsLoading = true

            try {
                const { status, data } = await httpClient.post(this.deleteItemUrl, {
                    id: this.itemToDelete.id
                })

                if (status === 200 && data?.success) {
                    this.$toast.add({
                        severity: 'success',
                        detail: this.$t('Data deleted'),
                        life: this.settings.toastLife
                    })

                    this.closeConfirmItemDeleteModal()

                    await this.getItems()

                    this.$emit('update-items')

                    this.updatedItemId = null
                    return data
                }

                if (data?.error) {
                    const errorKey = {
                        last_owner_assignment: 'lastOwnerRoleAssignmentDeleteWarn',
                    }[data.error]

                    this.$toast.add({
                        severity: 'warn',
                        detail: errorKey ? this.$t(errorKey) : this.$t('Unknown error'),
                        life: this.settings.toastLife,
                    })

                    return data
                }

                this.$toast.add({
                    severity: 'error',
                    detail: data?.error?.summary || data?.message || this.$t('Unknown error'),
                    life: this.settings.toastLife
                })

                return null
            } catch (err) {
                const errorCode = err.response?.data?.error?.code

                if (errorCode === 'tax_is_company_default') {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('taxIsInUseTitle'),
                        detail: this.$t('taxIsInUseDeleteError'),
                        life: this.settings.toastLife * 2,
                    })
                } else {
                    this.showError(err)
                }

                return null
            } finally {
                this.modalDataIsLoading = false
            }
        },

        async deleteEmailAccount() {
            const result = await this.deleteItem()

            if (result?.success) {
                await this.$store.dispatch('reloadLocationBootstrapData')
            }

            return result
        },

        // resetPaginationAndGetItems() {
        //     // this.resetRouteAndPagination()
        //     this.getItems()
        // },
        changeDatesRange({ fromTimestamp, toTimestamp }, loadData = false) {
            this.fromTimestamp = fromTimestamp
            this.toTimestamp = toTimestamp
            this.resetCurrentPageData()
            if (loadData) {
                this.getItems()
            }
        },
        changeOrderStateToWaitingOnClick(orderData) {
            if (!orderData) return
            this.orderToWaitingData = orderData
            this.openChangeOrderToWaitingModal()
        },
        async changeOrderStateToWaiting(obj) {
            if (!this.orderToWaitingData?.id) return
            this.dataIsSending = true

            try {
                await this.$refs['orderStateBtn-' + this.orderToWaitingData.id]?.changeOrderState(3, true, obj.staffComment)
            } catch(err) {
                this.showError(err)
            } finally {
                this.closeChangeOrderToWaitingModal()
                this.dataIsSending = false
            }
        },
        openChangeOrderToWaitingModal() {
            this.changeOrderToWaitingModal = true
            this.$store.commit('toggleFirstLayer', true)
        },
        closeChangeOrderToWaitingModal() {
            this.changeOrderToWaitingModal = false
            this.$store.commit('toggleFirstLayer', false)
        },
        changeProcessedSearchValue(value) {
            this.processedSearchValue = value
        },
        clearLastSearching() {
            this.$refs.searchInput?.clearLastSearchingValue()
        },
        resetCurrentPageData() {
            this.pagination.totalCount = null
            this.pagination.pageCount = null
            this.pagination.currentPage = 1
            // this.pagination.perPage = 25

            const route = {
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                }
            }

            delete route.query.page

            // this.getItemsAfterRouteChanging = false
            // this.$router.push(route).then(() => this.getItemsAfterRouteChanging = true)

            this.getItemsAfterRouteChanging = false

            this.$router.push(route)
                .catch(() => {})
                .finally(() => {
                    this.getItemsAfterRouteChanging = true
                })
        },
        resetRouteAndPagination(keepSupplier = false) {
            this.pagination.currentPage = 1
            this.pagination.perPage = 25

            const query = {}

            if (keepSupplier && this.$route.query.supplier) {
                query.supplier = this.$route.query.supplier
            }

            this.$router.push({
                path: this.$route.path,
                query,
            })

            this.searchData = null
            this.processedSearchValue = null
        },
        // resetPagination() {
        //     this.pagination.currentPage = 1
        //     this.pagination.perPage = 25
        // },
        generateThisMonthRange() {
            // console.log('generateThisMonthRange')
            let now = new Date()
            let firstDayOfCurrMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 1)

            const calculatedFirstDayOfCurrMonth =  firstDayOfCurrMonth ? this.calculateDayStartDate(firstDayOfCurrMonth) : null
            const toDate = this.calculateDayEndDate(now)

            this.datesRange = [calculatedFirstDayOfCurrMonth, toDate]
            this.fromTimestamp = calculatedFirstDayOfCurrMonth ? +calculatedFirstDayOfCurrMonth / 1000 : null
            this.toTimestamp = toDate ? +toDate / 1000 : null
        },

        changeRequestFilters() {
            this.resetRouteAndPagination(true)
            this.getItems()
        },

        changeCustomerAndContactPersonStatus({ newStatus, userId }) {
            if (userId == null || newStatus == null) return

            this.items?.forEach(item => {
                if (+item.customer?.id === +userId) {
                    if (!item.customer.customerStatus) {
                        item.customer.customerStatus = {}
                    }

                    item.customer.customerStatus.status_id = newStatus
                }

                if (+item.contactPerson?.id === +userId) {
                    if (!item.contactPerson.customerStatus) {
                        item.contactPerson.customerStatus = {}
                    }

                    item.contactPerson.customerStatus.status_id = newStatus
                }
            })
        },

        changeCustomerStatus(newStatus, userId) {
            if (userId == null || !Array.isArray(this.items)) return

            this.items.forEach(item => {
                const itemUserId = item.user_id ?? item.customer?.id

                if (+itemUserId !== +userId || !item.customer) return

                if (!item.customer.customerStatus) {
                    item.customer.customerStatus = {}
                }

                item.customer.customerStatus.status_id = newStatus
            })
        },


        toggleShowPositionTable(item, positionsEmpty = false, getPositions = false) {
            if (positionsEmpty || !item) return false
            item.showPositionsTable = !item.showPositionsTable
            this.openedItemsIds = this.items?.filter(item => item.showPositionsTable)?.map(i => { return i.id })
            if (item.showPositionsTable && getPositions && !item.positionsLoaded) {
                this.getOrderPositions(item)
            }
        },
        updateItems(itemId, getItems = true, showSpinner = false, clearItem = false) {
            this.updatedItemsIds = []
            if (itemId && +itemId) {
                this.updatedItemId = Number(itemId)
            }
            if (clearItem) {
                this.item = {}
                this.submitted = false
            }
            if (getItems) {
                this.getItems(showSpinner)
            }
            this.$emit('update-items') // Important: this is for update items in parent TAB component
        },
        closeItemModal() {
            this.itemModal = false
            this.$store.commit('toggleFirstLayer', false)
            this.submitted = false
        },
        addNewItem() {
            if (this.billingActionIsRestricted?.()) return false

            this.item = {isNew: true}
            this.submitted = false
            this.itemModal = true
            this.$store.commit('toggleFirstLayer', true)
        },
        editItem(item) {
            if (this.billingActionIsRestricted?.()) return false

            if (!item) return
            this.item = {...item}
            this.itemModal = true
            this.$store.commit('toggleFirstLayer', true)
        },
        confirmItemDelete(itemToDelete, id = null) {
            if (this.billingActionIsRestricted?.()) return false
            if (!itemToDelete) return

            this.itemToDelete = {...itemToDelete}
            if (id) this.itemToDelete.id = id
            this.confirmItemDeleteModal = true
            this.$store.commit('toggleFirstLayer', true)
        },
        closeConfirmItemDeleteModal() {
            this.itemToDelete = {}
            this.confirmItemDeleteModal = false
            this.$store.commit('toggleFirstLayer', false)
        },
        confirmItemsMultipleDelete() {
            if (this.billingActionIsRestricted?.()) return false

            this.confirmItemsMultipleDeleteModal = true
            this.$store.commit('toggleFirstLayer', true)
        },
        closeConfirmItemsMultipleDeleteModal() {
            this.confirmItemsMultipleDeleteModal = false
            this.$store.commit('toggleFirstLayer', false)
        },
        // async processDeleteItem(address, id) {
        //     if (!address || !id) return
        //     this.confirmDeleteModalIsLoading = true
        //     this.dataTableIsLoading = true
        //     this.disableEditButton = true
        //     try {
        //         const { status } = await httpClient.post(address, {id})
        //         if (status === 204) {
        //             this.closeConfirmItemDeleteModal()
        //             this.getItems()
        //         } else {
        //             this.showUnknownError()
        //         }
        //     } catch(err) {
        //         this.showError(err)
        //     } finally {
        //         this.confirmDeleteModalIsLoading = false
        //     }
        // },
        checkRouteQuery() {
            if (this.$route.query.page) {
                const page = Number(this.$route.query.page)
                this.pagination.currentPage = Number.isFinite(page) && page > 0 ? page : 1
            } else {
                this.pagination.currentPage = 1
            }

            const perPage = Number(this.$route.query.perPage)

            if (Number.isFinite(perPage) && perPage > 0) {
                if (this.$route.path === '/estimates' && perPage > 50) {
                    this.pagination.perPage = 50
                } else {
                    this.pagination.perPage = perPage > 200 ? 200 : perPage
                }
            } else if (this.$route.path === '/orders') {
                let localStorageOrdersPerPage = Number(localStorage.getItem('ordersPerPage') || 25)

                if (!Number.isFinite(localStorageOrdersPerPage) || localStorageOrdersPerPage <= 0) {
                    localStorageOrdersPerPage = 25
                }

                if (localStorageOrdersPerPage > 100) {
                    localStorageOrdersPerPage = 100
                }

                this.pagination.perPage = localStorageOrdersPerPage

                if (this.pagination.perPage !== 25) {
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            page: 1,
                            perPage: this.pagination.perPage
                        }
                    })
                }
            } else {
                this.pagination.perPage = 25
            }

            //!!!!! DONT DELETE
            // if (this.$route.path === '/orders' && this.pagination.perPage !== 25) {
            //     console.log(this.$route.path)
            //     this.pagination.perPage = +localStorage.getItem('ordersPerPage') ?? 25
            //     this.$router.push({
            //         path: this.$route.path,
            //         query: {
            //             ...this.$route.query,
            //             page: 1,
            //             perPage: this.pagination.perPage
            //         }
            //     })
            // } else if (this.$route.path === '/offers' && this.pagination.perPage !== 25) {
            //     this.pagination.perPage = +localStorage.getItem('offersPerPage') ?? 25
            //     this.$router.push({
            //         path: this.$route.path,
            //         query: {
            //             ...this.$route.query,
            //             page: 1,
            //             perPage: this.pagination.perPage
            //         }
            //     })
            // }


            if (this.$route.query.sort) {
                const firstSign = this.$route.query.sort[0]
                if (firstSign === '-') {
                    this.sort.direction = '-'
                    let sortColumn = this.$route.query.sort.split('')
                    this.sort.column = sortColumn.splice(1).join('')
                } else {
                    this.sort.direction = ''
                    this.sort.column = this.$route.query.sort
                }
            }

            //!!!!! DONT DELETE
            // if (this.$route.query.category) {
            //     this.selectedCategoryId = +this.$route.query.category
            //     const key = this.categoriesList[0].children.find(child => child.id === +this.$route.query.category)?.key
            //     if (key)  {
            //         const obj = {}
            //         obj[key] = true
            //         this.selectedCategory = {...obj}
            //     } else {
            //         this.selectedCategory = { 0: true }
            //         this.selectedCategoryId = null
            //     }
            // } else {
            //     this.selectedCategory = { 0: true }
            //     this.selectedCategoryId = null
            // }
            // if (this.$route.query.category) {
            this.selectedCategoryId = this.$route.query.category ? +this.$route.query.category : null

            //!!!!! DONT DELETE
            //     const key = this.categoriesList[0].children.find(child => child.id === +this.$route.query.category)?.key
            //     if (key)  {
            //         const obj = {}
            //         obj[key] = true
            //         this.selectedCategory = {...obj}
            //     } else {
            //         this.selectedCategory = { 0: true }
            //         this.selectedCategoryId = null
            //     }
            // } else {
            //     this.selectedCategory = { 0: true }
            //     this.selectedCategoryId = null
            // }

            // if (this.$route.query.type) {
            //     this.selectedTypeId = +this.$route.query.type
            //     const type = this.ReducedPositionTypes?.find(pos => pos.id === this.selectedTypeId)
            //     if (type)  {
            //         this.selectedType = type
            //     } else {
            //         this.selectedType = null
            //         this.selectedTypeId = null
            //     }
            // } else {
            //     this.selectedType = null
            //     this.selectedTypeId = null
            // }

            this.selectedTypeId = this.$route.query.type ? +this.$route.query.type : null

            if (this.$route.query.search) {
                this.searchData = this.$route.query.search
                this.processedSearchValue = this.searchData
            } else {
                this.searchData = null
                this.processedSearchValue = null
            }

            this.selectedSupplierId = this.$route.query.supplier ? this.$route.query.supplier : null
        },
        checkAllItemsAreSelected() {
            if (!this.items) return false
            let allItemsAreSelected = true
            this.items.forEach(item => {
                if (!this.isItemSelected(item.id)) {
                    allItemsAreSelected = false
                }
            })

            if (allItemsAreSelected && this.selectedItems?.length) {
                this.selectAllCheckbox = [0]
            } else {
                this.selectAllCheckbox = []
            }
        },
        selectAllCheckboxOnClick() {
            if (this.selectAllCheckbox?.length) {
                this.unselectAllItems()
            } else {
                this.selectAllItems()
            }
        },
        selectAllItems() {
            if (!this.items) return false
            this.items.filter(item => !this.isItemSelected(item.id)).forEach(item => this.selectedItems.push(item.id))
        },
        unselectAllItems(clearAll = false) {
            this.selectAllCheckbox = []
            this.showDetailedInfo = false

            if (clearAll) {
                this.selectedItems = []
                return
            }

            if (!this.items) return

            const currentItemIds = this.items.map(item => item.id)
            this.selectedItems = this.selectedItems.filter(id => !currentItemIds.includes(id))
        },
        searchItems(searchData) {
            this.searchData = searchData

            const route = {
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    search: this.searchData,
                }
            }
            if (!this.searchData) {
                this.searchData = null
                delete route.query.search
            }
            this.$router.push(route)
        },
        // searchButtonOnClick() {
        //     const route = {
        //         path: this.$route.path,
        //         query: {
        //             ...this.$route.query,
        //             search: this.searchData,
        //         }
        //     }
        //
        //     if (this.searchData !== this.$route.query.search) {
        //         this.isLoading = true
        //     }
        //
        //     if (!this.searchData) {
        //         // this.searchData = null
        //         this.searchData = null
        //         delete route.query.search
        //     }
        //
        //     this.$router.push(route)
        // },
        // resetSearch() {
        //     this.searchData = null
        //     if (this.$route.query.search) {
        //         const route = {
        //             path: this.$route.path,
        //             query: {
        //                 ...this.$route.query,
        //                 search: null,
        //             }
        //         }
        //         delete route.query.search
        //
        //         this.isLoading = true
        //         this.$router.push(route)
        //     }
        // },
        sortItems(columnName, changeRoute = true) {
            if (this.sort.column !== columnName) {
                this.sort.direction = ''
            } else {
                this.sort.direction = this.sort.direction === '' ? '-' : '';
            }
            this.sort.column = columnName

            if (changeRoute) {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        sort: this.sort.direction + this.sort.column
                    }
                })
            }
        },
        isItemUpdated(itemId) {
            const id = Number(itemId)

            if (!id) return false

            return this.updatedItemId === id || this.updatedItemsIds.includes(id)
        },
        isItemAdded(itemId) {
            return this.addedItems.indexOf(itemId) !== -1
        },
        isItemSelected(itemId) {
            return this.selectedItems.indexOf(itemId) !== -1
        },
        async reloadLocationItems() {
            if (this.$route?.query && Object.keys(this.$route.query).length) {
                await this.$router.replace({ path: this.$route.path, query: {} })
            }

            this.searchData = null
            this.$store.commit('closeAllLayers')

            this.selectedSupplier = null
            this.selectedSupplierId = null
            this.supplierSearchData = null
            this.$refs.selectedSupplierDropdown?.clearFilterValue?.()


            this.selectedType = null
            this.$refs.notificationTypesDropdown?.clearFilterValue?.()

            this.selectedCategory = null
            this.$refs.selectedCategoryDropdown?.clearFilterValue?.()

            this.$refs.customerTypesDropdown?.clearFilterValue?.()

            this.selectedCashbox = null

            this.showDetailedInfo = false
            this.showOnlyUnpaid = false

            this.showNotActive = false

            this.pagination.totalCount = null
            this.pagination.pageCount = null
            this.pagination.currentPage = 1

            this.isLoading = true
            await this.getPageData?.()
        },
        getAccountingExportTooltip(item) {
            const provider = item.accounting_provider_name;

            return provider
                ? `${this.$t('exportedToAccountingLabel')} ${provider}`
                : this.$t('exportedLabel');
        },
    },
    mounted() {
        this.routePathAtMount = this.$route.path

        this._reloadHandler = () => {
            if (document.visibilityState !== 'visible') return
            this.reloadLocationItems()
        }

        if (this.$store.getters.isSystemMode) {
            this.$store.commit('updateLocationData', { locale: 'et-EE', currency: 'EUR', timezone: 'Europe/Tallinn'})
        }

        window.addEventListener('vg:reload-current-page', this._reloadHandler)

        requestAnimationFrame(() => {
            this.showModals = true
        })
    },
    unmounted() {
        window.removeEventListener('vg:reload-current-page', this._reloadHandler)
        this.items = []
        this.isLoading = false
        this.$store.commit('closeAllLayers')
    },
    computed: {
        itemToDeleteData() {
            return null
        },
        userCanGetData() { return this.$store.getters.userCanGetData },
        fetchInFlight() { return this.$store.getters.fetchInFlight },
        isFocusMode() {
            return !!this.$route.query.show && !this.$route.query.search
        },
        itemsArrayIsEmpty() {
            return !(this.items?.length)
        },
        allCurrentItemsAreAdded() {
            let result = true
            this.items?.forEach(item => {
                if (!this.isItemAdded(item.id)) {
                    result = false
                }
            })
            return result
        },
        showAccountingExportColumn() {
            const integrationIsActive = !!this.$store.getters.accountingIntegration

            const hasExportedInvoices = (this.items ?? []).some(item =>
                item.accounting_integration_id ||
                item.export_id ||
                item.export_number
            )

            return integrationIsActive || hasExportedInvoices
        }
    }
}

export default datatableMixins
